export default "__VITE_ASSET__CQRT_D3f__"